import styled from 'styled-components';
import { Typography } from '../../global/theme';
import { AlignCenter, LineClamp, ShowVerticalScrollbar } from '../../global/commonStyle';

const BottomDiv = styled.div`
  padding: var(--space-12) var(--space-12) var(--space-16);
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
`;

const Heading = styled.p`
  margin: var(--space-0);
  padding-inline: var(--space-8);
  ${Typography.body_sm_medium}
  color: var(--text-secondary);
`;

const List = styled.li`
  list-style-type: none;
  max-height: 256px;
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  ${ShowVerticalScrollbar}
`;

const Task = styled.div`
  padding: var(--space-8);
  ${AlignCenter}
  gap: var(--space-12);
  border-radius: var(--border-radius-8);
  &:hover {
    cursor: pointer;
    background-color: var(--neutral-secondary);
  }
`;

const Status = styled.span``;

const TaskHeading = styled.p`
  margin: var(--space-0);
  ${Typography.body_md}
  ${LineClamp(1)}
  word-break: break-all;
  color: var(--text-secondary);
`;

export { BottomDiv, Heading, Task, Status, TaskHeading, List };
